import Link from "next/link";
import PageHead from "./Head";
import { ROUTE } from "@/route/app_routes.js";

// Intentionally standalone -- no Redux/Context, no Header/Footer (both fetch live data
// that will just hang or fail while offline). The service worker precaches this exact
// page so it can render fully from cache with zero network calls, and next-pwa serves it
// automatically for any navigation that misses the cache while the visitor is offline.
const OfflinePage = () => {
  return (
    <>
      <PageHead title="You're offline" noindex />
      <main
        style={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          padding: "32px",
          gap: 18,
        }}
      >
        <span
          style={{
            width: 64,
            height: 64,
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "var(--gradient-7)",
            color: "#fff",
            fontSize: 26,
          }}
        >
          <i className="feather-wifi-off"></i>
        </span>

        <h1 style={{ fontSize: 26, fontWeight: 700, color: "var(--color-heading)", margin: 0 }}>
          You&apos;re offline
        </h1>
        <p style={{ maxWidth: 420, color: "var(--color-body)", fontSize: 15, margin: 0 }}>
          This page hasn&apos;t been saved for offline use yet. Reconnect to the internet
          and try again, or head back to a page you&apos;ve already visited.
        </p>

        <div style={{ display: "flex", gap: 12, marginTop: 6, flexWrap: "wrap", justifyContent: "center" }}>
          <button
            type="button"
            className="rbt-btn btn-gradient"
            onClick={() => window.location.reload()}
          >
            <span className="btn-text">Try again</span>
          </button>
          <Link className="rbt-btn btn-border" href={ROUTE.home}>
            <span className="btn-text">Go to homepage</span>
          </Link>
        </div>
      </main>
    </>
  );
};

export default OfflinePage;
